export default {
  signIn: 'Login',
  signUp: 'Start Now',
  getStarted: 'Get Started',
};
